import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Collections } from "../components/site/Sections";

export default function CollectionsPage() {
  return (
    <>
      <SEO
        title="Product Collections for Hotels & Restaurants | Emporium London"
        description="Explore Emporium London's eight product collections — tableware, barware, chess & games, planters, candles & scent, decor objects, branded gifting and textiles — for hospitality and corporate clients."
        path="/collections"
      />
      <main>
        <PageHeader
          overline="Product Collections"
          title="Curated product collections for hospitality & corporate spaces"
          intro="Eight signature ranges of decor, tableware and gifting — supplied to hotel groups, multi-site restaurants and corporate workspaces, and fully customisable to your brand and theme."
        />
        <Collections />
      </main>
    </>
  );
}
